const mediaItems = [
  {
    thumbnail: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20coral%20tones%20video%20player%20concept%20play%20button%20shape%20dynamic%20composition%20modern%20minimalist%20digital%20art%20clean%20aesthetic&width=800&height=450&seq=mrds-media-01&orientation=landscape",
    title: "本周爆料热点视频回顾：这些瓜你吃了几个？",
    duration: "15:28",
    views: "12.3万",
  },
  {
    thumbnail: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20amber%20gold%20tones%20entertainment%20show%20concept%20microphone%20shapes%20modern%20minimalist%20digital%20art%20clean%20design&width=800&height=450&seq=mrds-media-02&orientation=landscape",
    title: "独家访谈：业内人揭秘娱乐圈运作内幕",
    duration: "22:10",
    views: "9.8万",
  },
  {
    thumbnail: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20peach%20orange%20tones%20comedy%20sketch%20concept%20theater%20masks%20shapes%20modern%20minimalist%20digital%20art%20clean%20aesthetic&width=800&height=450&seq=mrds-media-03&orientation=landscape",
    title: "搞笑合集：那些让网友笑到停不下来的名场面",
    duration: "08:45",
    views: "15.6万",
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-10 text-center">
          精彩视频
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <a key={i} href="#about" className="group block bg-background-100 rounded-2xl overflow-hidden cursor-pointer">
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-200"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 bg-foreground-900/70 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400">{item.views} 次观看</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}